import Vue from 'vue'
import Vuex from 'vuex'
import cloneDeep from 'lodash.clonedeep'

Vue.use(Vuex)

const createUUID = () => {
  var dt = new Date().getTime();
  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    var r = (dt + Math.random()*16)%16 | 0;
    dt = Math.floor(dt/16);
    return (c=='x' ? r :(r&0x3|0x8)).toString(16);
  });
  return uuid;
}

const DEFAULT_SNACKBAR = {
  timeout: 1000 * 5,
  type: 'info',
  message: 'no message',
}

export default new Vuex.Store({
  state: {
    positions: [],
    locations: [],
    places: [],
    timeGroups: [],
    types: [],

    snackbars: [],
  },
  getters: {
    positions: state => state.positions,
    locations: state => state.locations,
    places: state => state.places,
    timeGroups: state => state.timeGroups,
    types: state => state.types,

    snackbars: state => state.snackbars,
  },
  mutations: {
    setPositions(state, vals) {
      state.positions = vals
    },
    setLocations(state, vals) {
      state.locations = vals
    },
    setPlaces(state, vals) {
      state.places = vals
    },
    setTimeGroups(state, vals) {
      state.timeGroups = vals
    },
    setTypes(state, vals) {
      state.types = vals
    },

    removeSnackbar(state, uuid) {
      Vue.delete(state.snackbars, state.snackbars.findIndex(s => s.uuid == uuid))
    },
    addSnackbar(state, val) {
      state.snackbars.push(val)
    },
  },
  actions: {
    addSnackbar({ commit }, val) {
      // create item with default settings
      var snackbarItem = cloneDeep(DEFAULT_SNACKBAR)

      // if input is string => set input (string) to message field
      if (typeof val === 'string' || val instanceof String) {
        val = {
          message: val
        }
      }

      // add UUID
      snackbarItem.uuid = createUUID()

      // merge defaults with input value
      snackbarItem = Object.assign({}, snackbarItem, val)

      // commit to store
      console.log('adding', snackbarItem)
      commit('addSnackbar', snackbarItem)

      // if timeout => set autoremove
      if (snackbarItem.timeout > 0) {
        setTimeout(() => {
          console.log('removing snackbar (timer)...')
          commit('removeSnackbar', snackbarItem.uuid)
        }, snackbarItem.timeout)
      }

      return snackbarItem
    },
  },
  modules: {
  }
})
